<template>
  <div class="articles__article">
    <div class="articles__background"></div>
    <div class="articles__background--white">
      <div class="articles__article__back"><router-link :to="{ name: 'solutions', hash: '#articoli' }">Soluzioni</router-link></div>

      <h1 class="articles__article__title">{{ currentArticle.title }}</h1>

      <div v-html="currentArticle.content" class="articles__article__content"></div>

      <div class="articles__article__next-article">
        <router-link
          v-if="nextArticle"
          :to="{ name: 'article', params: { slug: nextArticle.slug } }">
          {{ nextArticle.title }}
        </router-link>
        <div class="articles__article__back"><router-link :to="{ name: 'solutions', hash: '#articoli' }">tutte le soluzioni</router-link></div>
      </div>
    </div>

    <global-footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import GlobalFooter from '../components/GlobalFooter'

export default {
  components: {
    GlobalFooter
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('articles', [
      'article',
      'list'
    ]),
    currentArticle: {
      get () {
        return this.article(this.slug)
      }
    },
    nextArticle: {
      get () {
        return this.list[_.findIndex(this.list, a => this.currentArticle.slug === a.slug) + 1] || this.list[0]
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getArticles()
    })
  },
  methods: {
    ...mapActions('articles', [
      'getArticles'
    ])
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';

.articles__article {
  background-color: white;
  position: absolute;
  color: #0a2f74;
  z-index: 110;
  box-sizing: border-box;

  @include media(">=large") {
    width: 85%;
  }

  .articles__background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #0487a3;
    z-index: -1;
  }

  .articles__background--white {
    background-color: white;
  }

  .articles__article__back {
    text-transform: uppercase;
    font-size: 1.6rem;
    line-height: 5rem;
    margin: 0 7.5% 20px 7.5%;
    padding-top: 130px;
    position: relative;
    padding-left: 30px;

    @include media(">=large") {
      margin: 0 15% 20px 15%;
      padding-top: 260px;
    }

    a {
      text-decoration: none;
      color: #0a2f74;
      font-weight: 600;
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        transform: rotate(180deg) scale(.6) translateX(50px);
        content: "";
        background-image: url("data:image/svg+xml,%3Csvg width='30px' height='19px' viewBox='0 0 30 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EShape%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='DESKTOP' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='06_Soluzioni' transform='translate(-248.000000, -2426.000000)' fill-rule='nonzero' fill='%230A2F74'%3E%3Cg id='back' transform='translate(263.000000, 2435.500000) rotate(-180.000000) translate(-263.000000, -2435.500000) translate(248.000000, 2426.000000)'%3E%3Cpath d='M9.9159292,1.45659908 C10.2477876,1.13215937 10.2477876,0.577908218 9.9159292,0.253468517 C9.59734513,-0.0844895055 9.06637168,-0.0844895055 8.73451327,0.253468517 L0.238938053,8.89167556 C-0.0796460177,9.22963358 -0.0796460177,9.77036642 0.238938053,10.1083244 L8.73451327,18.7465315 C9.06637168,19.0844895 9.59734513,19.0844895 9.9159292,18.7465315 C10.2477876,18.4220918 10.2477876,17.8678406 9.9159292,17.5434009 L2.86725664,10.3651725 L29.1637168,10.3651725 C29.6283186,10.3651725 30,9.97314123 30,9.5 C30,9.02685877 29.6283186,8.64834578 29.1637168,8.64834578 L2.86725664,8.64834578 L9.9159292,1.45659908 Z' id='Shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        width: 30px;
        height: 19px;
      }

      &:after{
        display: block;
        content: "";
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: #0a2f74;
        transform: scaleX(0);
        transform-origin: right;
        transition: transform .3s ease-out;
      }

      &:hover{
        &:after{
          transform: scaleX(1);
          transform-origin: left;
        }
      }
    }
  }

  .articles__article__title {
    font-size: 4.25rem;
    line-height: 1.2;
    margin: 0 7.5%;

    @include media(">=large") {
      font-size: 7rem;
      line-height: 9rem;
      margin: 0 15%;
    }
  }

  h2 {
    font-size: 1.6rem;
    line-height: 5rem;
    font-weight: 600;
    margin-top: 140px;
    margin: 80px 7.5% 20px 7.5%;
    text-transform: uppercase;

    @include media(">=large") {
      font-size: 1.6rem;
      line-height: 5rem;
      font-weight: 600;
      margin-top: 140px;
      margin: 160px 15% 20px 15%;
    }
  }

  h3 {
    font-size: 2.5rem;
    line-height: 4.8rem;
    margin: 20px 7.5% 20px 7.5%;

    @include media(">=large") {
      font-size: 3.1rem;
      margin: 20px 15% 20px 15%;
    }
  }

  ul {
    margin: 20px 7.5% 20px 7.5%;
    padding: 0;
    list-style: none;

    @include media(">=large") {
      margin: 20px 15% 20px 15%;
    }
    li {
      &::before {
        content: "";
        display: inline-block;
        margin-right: 1.5rem;
        height: 2px;
        width: 20px;
        background-color: #0a2f75;
        -webkit-transform: translateY(-0.5rem);
        transform: translateY(-0.5rem);
      }
    }
  }

  p {
    font-size: 1.8rem;
    line-height: 3.6rem;
    margin: 0px 7.5% 40px 7.5%;

    @include media(">=large") {
      margin: 0px 15% 40px 15%;
    }
  }

  p {
      &:last-of-type {
        margin: 0;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
  }

  blockquote {
    margin: 80px 0 0 0;
  }

  blockquote p {
    background-color: #001b53;
    color: #f2f2f2;
    font-size: 2.1rem;
    line-height: 4rem;
    padding: 12% 7.5%;
    box-sizing: border-box;
    margin: 0px 15% 40px 15%;
    margin-bottom: 0;

    @include media(">=large") {
      padding: 100px 270px 100px 120px;
      font-size: 3.1rem;
      line-height: 4.8rem;
    }

    &:last-of-type {
      margin: 0px 0 40px 0%;
      margin-bottom: 0;

      @include media(">=large") {
        margin: 0px 0 40px 15%;
        margin-bottom: 0;
      }
    }
  }

  .articles__article__next-article {
    background-color: #001b53;
    color: white;
    font-size: 3rem;
    line-height: 400px;
    text-align: center;
    position: relative;
    min-height: 150px;
    padding: 7.5%;

    @include media(">=large") {
      font-size: 4rem;
    }

    a {
      color: white;
      text-decoration: none;
      position: relative;
      display: inline-block;
      line-height: 1.3;

      &:after{
        display: block;
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: white;
        transform: scaleX(0);
        transform-origin: right;
        transition: transform .3s ease-out;
      }

      &:hover{
        &:after{
          transform: scaleX(1);
          transform-origin: left;
        }
      }
    }

    .articles__article__back {
      background-color: #001b53;
      font-size: 1.6rem;
      line-height: 50px;
      position: absolute;
      bottom: 15%;
      left: 3.25%;
      margin: 0;
      padding-top: 0;

      a {
        color: white;
        text-decoration: none;
        text-overflow: ellipsis;
        white-space: nowrap;

      &::before {
        position: absolute;
        top: 0;
        transform: rotate(180deg) scale(.6) translateX(50px) translateY(0px);
        content: "";
        background-image: url("data:image/svg+xml,%3Csvg width='30px' height='19px' viewBox='0 0 30 19' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EShape%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='DESKTOP' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='06_Soluzioni' transform='translate(-248.000000, -2426.000000)' fill-rule='nonzero' fill='%23FFFFFF'%3E%3Cg id='back' transform='translate(263.000000, 2435.500000) rotate(-180.000000) translate(-263.000000, -2435.500000) translate(248.000000, 2426.000000)'%3E%3Cpath d='M9.9159292,1.45659908 C10.2477876,1.13215937 10.2477876,0.577908218 9.9159292,0.253468517 C9.59734513,-0.0844895055 9.06637168,-0.0844895055 8.73451327,0.253468517 L0.238938053,8.89167556 C-0.0796460177,9.22963358 -0.0796460177,9.77036642 0.238938053,10.1083244 L8.73451327,18.7465315 C9.06637168,19.0844895 9.59734513,19.0844895 9.9159292,18.7465315 C10.2477876,18.4220918 10.2477876,17.8678406 9.9159292,17.5434009 L2.86725664,10.3651725 L29.1637168,10.3651725 C29.6283186,10.3651725 30,9.97314123 30,9.5 C30,9.02685877 29.6283186,8.64834578 29.1637168,8.64834578 L2.86725664,8.64834578 L9.9159292,1.45659908 Z' id='Shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        width: 30px;
        height: 19px;
      }

        &:after{
          background: white;
        }
      }
    }
  }

  footer {
    width: 100vw;

    p {
      font-size: 1.25rem;
      margin: 0;
      line-height: 1.7;
    }
  }
}
</style>
